module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[91]578.5e57cc9.woff2";